import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

function PricePlaceholder() {
  return (
    <Component>
      <Price />
      <Price />
      <Currency />
    </Component>
  );
}

export default PricePlaceholder;

const Component = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: flex-end;
`;

const Price = styled.div`
  height: 48px;
  width: 60px;
  margin: 6px 6px 0 0;
  border-radius: 8px;
  ${placeholderAnimationCss}

  ${media.laptopOnly(css`
    height: 29px;
    width: 50px;
  `)}

  ${media.mobile(css`
    height: 29px;
    width: 50px;
  `)}
`;

const Currency = styled.div`
  height: 22px;
  width: 35px;
  border-radius: 8px;
  ${placeholderAnimationCss}

  ${media.laptopOnly(css`
    height: 12px;
    width: 20px;
  `)}

  ${media.mobile(css`
    height: 12px;
    width: 20px;
  `)}
`;
